import { generatePath } from 'react-router-dom'
import { SEO_RELEVANCE_PATH } from 'paths'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { FileMultiple } from 'blaze-ui/icons'
import { Pill } from 'components/Pill/Pill'
import Styles from '../NavMenu.module.scss'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuSeoRelevanceItem = ({ workspaceId, onPress }: Props) => {
  // The new SEO/AEO experience is in beta; legacy users keep the plain "SEO" label.
  const isSeoAeo = useFlipperFlag('seo_aeo')

  return (
    <NavMenuItem
      icon={FileMultiple}
      activeIcon={FileMultiple}
      to={generatePath(SEO_RELEVANCE_PATH, { workspaceId })}
      onPress={onPress}
      label={isSeoAeo ? 'SEO/AEO' : 'SEO'}
    >
      {isSeoAeo && (
        <Pill className={Styles.betaPill} size="sm">
          Beta
        </Pill>
      )}
    </NavMenuItem>
  )
}

export { NavMenuSeoRelevanceItem }
